import Vue from 'vue'
import moment from 'moment'
import VueMoment from 'vue-moment'
import Vuetify from 'vuetify'
import { i18n } from './localization/index'
import App from '@/App'
import router from '@/router'
import { store } from '@/store'
import interceptorsSetup from './axios'
import 'moment/locale/ru'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false
Vue.use(Vuetify, {
  theme: {
    primary: '#007AFF',
    secondary: '#52C22C',
    error: '#b71c1c',
    toolbar: '#2a7afe',
    sidebar: '#4292fc'
  }
})
Vue.use(VueMoment, {
  moment
})

interceptorsSetup()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js